
import { useContext } from '@nuxtjs/composition-api';
import useSearch from '@/composable/useSearch';

export default {
  props: {
    searchResult: {
      type: Object,
      default: () => {}
    }
  },
  setup () {
    const app = useContext()
    const { state, resetFilters } = useSearch(app)

    return {
      state,
      resetFilters
    }
  }
}
